class ShoppableGrid extends HTMLElement {
  constructor() {
    super();

    this.handle = this.dataset.blog;

    this.observer = new IntersectionObserver(
      (entries) => {
        for (let entry of entries) {
          this.sticky =
            entry.boundingClientRect.top < 0 &&
            entry.boundingClientRect.bottom > 0;
        }
      },
      { threshold: [0, 1] }
    );
    this.onScrollHandler = this.onScroll.bind(this);

    this.bindEvents();
  }

  onScroll() {
    if (this.sticky) {
      document
        .querySelector("sticky-header")
        .dispatchEvent(new CustomEvent("preventHeaderReveal"));
    }
  }

  connectedCallback() {
    document.addEventListener("scroll", this.onScrollHandler, {
      passive: true,
    });
  }

  disconnectedCallback() {
    this.observer.disconnect();
    document.removeEventListener("scroll", this.onScrollHandler, {
      passive: true,
    });
  }

  bindEvents() {
    this.querySelectorAll(".shoppable-grid__tag").forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        this.loadArticles(event.currentTarget.href);
      });
    });
    this.observer.observe(this.querySelector(".shoppable-grid__tags"));
    this.bindButton();
  }

  bindButton() {
    this.querySelector(".shoppable-grid__more a").addEventListener(
      "click",
      (event) => {
        event.preventDefault();
        this.loadMore(event.currentTarget.href);
      }
    );
  }

  async loadArticles(href = `/blogs/${this.handle}`) {
    let timeout = setTimeout(() => {
      this.querySelector(".loading-overlay").classList.remove("hidden");
    }, 500);

    try {
      const json = await fetch(`${href}?sections=shoppable-blog`).then(
        (response) => response.json()
      );

      const selector = ".shoppable-grid";

      const elementToFill = this.querySelector(selector);

      elementToFill.innerHTML = this.getSectionInnerHTML(
        json["shoppable-blog"],
        selector
      );

      this.bindEvents();
      window.lazyloadPolyfill(elementToFill);
    } catch (error) {
      console.error(error);
    }

    clearTimeout(timeout);
    this.querySelector(".loading-overlay").classList.add("hidden");
  }

  async loadMore(href) {
    let timeout = setTimeout(() => {
      this.querySelector(".shoppable-grid__more a").classList.add('loading');
    }, 500);

    try {
      const url = new URL(href);

      url.searchParams.set("sections", "shoppable-blog");

      const json = await fetch(url.toString()).then((response) =>
        response.json()
      );

      const selector =
        ".shoppable-grid__item:not(.shoppable-grid__item--square)";
      const elementToFill = this.querySelector(".shoppable-grid__grid");
      const DOM = new DOMParser().parseFromString(
        json["shoppable-blog"],
        "text/html"
      );
      DOM.querySelectorAll(selector).forEach((element) => {
        elementToFill.insertAdjacentElement("beforeend", element);
      });
      
      this.querySelector('.shoppable-grid__more').innerHTML = DOM.querySelector('.shoppable-grid__more').innerHTML;

      this.bindButton();
      window.lazyloadPolyfill(elementToFill);
    } catch (error) {
      console.error(error);
    }

    clearTimeout(timeout);
    this.querySelector(".shoppable-grid__more a").classList.remove('loading');
  }

  getSectionInnerHTML(html, selector) {
    const DOM = new DOMParser().parseFromString(html, "text/html");
    return DOM.querySelector(selector).innerHTML;
  }
}

customElements.define("shoppable-grid", ShoppableGrid);
